import { Form, Input, Modal, Switch } from 'antd';
import React, { useState } from 'react';
import { createCompany } from 'api/companies';
import { getData } from 'utils';
import { captureException } from 'utils/errors';
import { getHttpErrorMessage } from 'utils/http';
import { App } from 'antd';

function AddCompanyModal({ open, onClose, onSuccess }) {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const { message } = App.useApp();

  const handleOk = () => {
    form.validateFields().then((values) => {
      setSaving(true);
      createCompany(values)
        .then((res) => {
          const data = getData(res)?.data ?? getData(res) ?? res?.data ?? res;
          onSuccess?.(data);
          message.success('Company created');
          form.resetFields();
          onClose();
        })
        .catch((e) => {
          captureException(e);
          message.error(getHttpErrorMessage(e));
        })
        .finally(() => setSaving(false));
      return null;
    }).catch(() => {});
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Add Company"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={saving}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item name="name" label="Company Name" rules={[{ required: true }]}>
          <Input placeholder="Company name" />
        </Form.Item>
        <Form.Item name="industry" label="Industry">
          <Input placeholder="e.g. Technology, Healthcare" />
        </Form.Item>
        <Form.Item name="website" label="Website">
          <Input placeholder="https://..." type="url" />
        </Form.Item>
        <Form.Item name="notes" label="Notes">
          <Input.TextArea rows={3} placeholder="Notes..." />
        </Form.Item>
        <Form.Item name="is_active" label="Active" valuePropName="checked" initialValue={true}>
          <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddCompanyModal;
